<template>
  <div>
    <h6 class="mb-3">Presentation Details</h6>
    <b-form-group label="Name" label-for="presentation-name">
      <b-form-input
        id="presentation-name"
        :value="form.name"
        maxlength="250"
        required
        @input="updateField('name', $event)"
      ></b-form-input>
    </b-form-group>
    <b-form-group label="Description" label-for="presentation-description">
      <b-form-textarea
        id="presentation-description"
        :value="form.description"
        rows="4"
        maxlength="2500"
        @input="updateField('description', $event)"
      ></b-form-textarea>
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: "presentation-details-section",
  props: {
    form: {
      type: Object,
      required: true,
    },
  },
  methods: {
    updateField(field, value) {
      this.$emit("update", {
        ...this.form,
        [field]: value,
      });
    },
  },
};
</script>
